// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import request from '@/lib/utils'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.directive('removeAriaHidden', {
  bind (el, _binding) {
    const ariaEls = el.querySelectorAll('.el-radio__original')
    ariaEls.forEach((item) => {
      item.removeAttribute('aria-hidden')
    })
  }
})

router.beforeEach((to, _from, next) => {
  if (to.meta.requireAuth) {
    if (localStorage.getItem('auth-token')) {
      let token = localStorage.getItem('auth-token')
      request.get('/login/validateToken?token=' + token).then((res) => {
        if (res.obj === true) {
          next()
        } else {
          localStorage.removeItem('auth-token')
          next({
            path: '/login'
          })
        }
      })
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
}
)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js